import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: `${unit}px`,
      margin: `${unit * 1.5}px 0`,
    },
  });

export default styles;
